(() => {
    'use strict';

    // Replace the widget reference in the payload with the actual widget type and ID to match the API requirements.
    const putWidgetRef = (payload, widget) => {
        const selectVal = real.form.getDataPayload(widget.find('.source-widget-ref'))['source_widget_ref'];
        if (!selectVal) {
            return;
        }
        const [sourceWidgetType, sourceWidgetId] = selectVal.split('-');
        payload.source_widget_type = sourceWidgetType;
        payload.source_widget = sourceWidgetId;
        if (payload.source_widget_ref) {
            delete payload.source_widget_ref;
        }
    }

    const setSourceWidgetReference = (widget) => {
        const dataPayload = {
            user_prompt: widget.find('[name="user_prompt"]').val(),
        }
        putWidgetRef(dataPayload, widget);
        real.ajax.json(real.baseUri + '/api/widget/wordcloud/' + widget.data('widget-id'), {
            type: 'POST',
            data: JSON.stringify(dataPayload),
        });
    };

    const updateWordCloud = (e) => {
        const widget = $(e.currentTarget);
        const wordCloud = widget.find('.howspace-wordcloud-initialized');
        if (wordCloud.length > 0) {
            setTimeout(() => {
                howspace.components.wordcloud.update(wordCloud, wordCloud.data('items'));
            }, 10);
        }
    };

    howspace.widgets.wordcloud = {
        initView: widget => {
            widget.find('.save-btn').on('click', () => {
                setSourceWidgetReference(widget);
            });

            const container = widget.find('.wordcloud-container');
            if (container.data('requires-new-content')) {
                // Trigger the word cloud AI process.
                howspace.aiGen.setPromptTimeout(widget);
                real.ajax.json(real.baseUri + '/api/ai/wordcloud/start/' + widget.data('widget-id'), {
                    type: 'POST',
                    data: JSON.stringify([]),
                    error: () => {
                        container.html(`<div class="p-3">${howspace.translate('wordcloud_prompt_failed')}</div>`);
                        howspace.aiGen.clearPromptTimeout(widget);
                    }
                });
            }

            widget.on(howspace.fullscreen.FULLSCREEN_OPENED, updateWordCloud);
            widget.on(howspace.fullscreen.FULLSCREEN_CLOSED, updateWordCloud);
        },
        destroyView: widget => {
            // Empty for now.
        },
        initEdit: widget => {
            // Empty for now.
        },
        destroyEdit: widget => {
            // Empty for now.
        },
        save: (widget, dataPayload) => {
            putWidgetRef(dataPayload, widget);
            return dataPayload;
        },
    };
})();
